import React from 'react';
import { Dialog, DialogContent, Box } from "@material-ui/core";
import STAvatarSeletDialog from "../../assets/styles/organisms/avatarSelectDialog.module.scss";
import STButton from "../../assets/styles/atoms/button.module.scss";

type IconItem = {
  file_url: string;
  presign_url?: string;
};

type AvatarSelectDialogProps = {
  open: boolean;
  onClose: (newAvatar: string, isChange: boolean) => void;
  icons: IconItem[];
};

const AvatarSelectDialog: React.FC<AvatarSelectDialogProps> = ({ open, onClose, icons }) => {
  const [selectedAvatar, setSelectedAvatar] = React.useState<string>('');
  
  const handleSelectAvatar = (avatarUrl: string) => {
    setSelectedAvatar(avatarUrl);
  };

  return (
    <Dialog open={open} onClose={() => onClose(selectedAvatar, false)}  aria-labelledby="icon-select-dialog-title">
      <DialogContent>
        <div className={STAvatarSeletDialog.avatarGrid}>
          {icons.map((image, index) => (
            <img
              key={index}
              src={image.presign_url}
              alt={`avatar-${index}`}
              className={`${STAvatarSeletDialog.avatarImage} ${
                selectedAvatar === image.presign_url ? STAvatarSeletDialog.avatarImageActive : ""
              }`}
              onClick={() => handleSelectAvatar(image.presign_url ?? '')}
            />
          ))}
        </div>
      </DialogContent>
      <Box className={STAvatarSeletDialog.buttonGroup}>
        <button 
          type="button"
          className={`${STAvatarSeletDialog.submitButton} ${STButton.secondary}`} 
          onClick={() => onClose(selectedAvatar, true)} 
        >
          確定
        </button>
      </Box>
    </Dialog>
  );
};

export default AvatarSelectDialog;
